import { combineReducers } from '@reduxjs/toolkit'
import authReducer from '@/features/auth/store/authSlice'
import portfolioReducer from './portfolioSlice'
import assetsReducer from './assetsSlice'
import pricesReducer from './pricesSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  portfolio: portfolioReducer,
  assets: assetsReducer,
  prices: pricesReducer,
})

export default rootReducer
